"use client";

import { useTranslations } from "next-intl";

export interface ProgressBarProps {
  totalQuestions: number;
  currentQuestionIndex: number;
}

export default function ProgressBar({
  totalQuestions,
  currentQuestionIndex,
}: ProgressBarProps) {
  const t = useTranslations("aria");
  const percentage =
    totalQuestions > 0 ? (currentQuestionIndex / totalQuestions) * 100 : 0;

  return (
    <div
      className="progress-bar"
      role="progressbar"
      aria-label={t("progress-bar")}
      aria-valuenow={currentQuestionIndex}
      aria-valuemin={0}
      aria-valuemax={totalQuestions}
    >
      <div className="progress-bar-fill" style={{ width: `${percentage}%` }} />
    </div>
  );
}
